import { useValidCheckSingle } from "common/hooks/validCheck";
import { InputWrapper } from "common/components/Wrapper/InputBase";
import React, { useEffect, useState } from "react";
import { RadioItem } from "./RadioButtonItem";

export const RadioButtonGroup = ({
  //InputWrapper
  label,
  caption,
  direction = "column",

  //RadioButtonGroup
  name,
  value,
  onChange,
  required,
  disabled = false,
  children,
}) => {
  const isControlled =
    typeof value === "string" && typeof onChange === "function";

  const { inputProps, error, onValueChange } = useValidCheckSingle({
    name: name,
    rules: { required: required || false },
  });

  const [internalValue, setInternalValue] = useState(inputProps.value ?? "");
  const currentValue = isControlled ? value : internalValue;

  const handleSelect = (val) => {
    if (disabled) return;
    if (!isControlled) {
      setInternalValue(val);
      onValueChange(val);
    }
    onChange?.(val);
  };

  useEffect(() => {
    if (!isControlled && inputProps.value !== internalValue) {
      setInternalValue(inputProps.value);
      onValueChange(inputProps.value);
    }
  }, [inputProps.value]);

  return (
    <InputWrapper
      label={label}
      caption={caption}
      rules={{ required }}
      direction={direction}
      error={error}>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          name,
          checked: currentValue === child.props.value,
          disabled: disabled || child.props.disabled,
          onSelect: handleSelect,
          inputRef: index === 0 ? inputProps.ref : undefined,
        }),
      )}
    </InputWrapper>
  );
};

RadioButtonGroup.ByOptions = ({
  //InputWrapper
  label,
  caption,
  direction = "column",

  name,
  value,
  onChange,
  required,
  disabled = false,
  options,
}) => {
  return (
    <RadioButtonGroup
      label={label}
      caption={caption}
      name={name}
      direction={direction}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}>
      {options.map((opt) => (
        <RadioItem
          key={opt.value}
          label={opt.label}
          value={opt.value}
          disabled={opt.disabled}
        />
      ))}
    </RadioButtonGroup>
  );
};
